import styled from "@emotion/styled"

const StyledRedis = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 20px 22px 24px;
  border-radius: 24px;
  background: var(--cms-surface-primary);

  .heading-copy {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .page-title {
    margin: 0;
    font-size: 30px;
    font-weight: 800;
    color: var(--cms-text-primary);
    letter-spacing: -0.01em;
  }

  .page-subtitle {
    margin: 0;
    color: var(--cms-text-secondary);
    font-size: 13px;
    font-weight: 500;
  }

  .page-surface {
    border: 1px solid var(--cms-border);
    border-radius: 18px;
    background: var(--cms-surface-secondary);
    box-shadow: var(--cms-shadow);
    padding: 14px;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .search-bar {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    gap: 10px;
    border: 1px solid var(--cms-border);
    border-radius: 12px;
    background: var(--cms-surface-muted);
    box-shadow: 0 12px 24px rgba(15, 23, 42, 0.06);
    padding: 12px;

    .MuiTextField-root {
      flex: 1;
      margin: 0;
    }

    .MuiInputBase-root {
      border-radius: 10px;
      background: var(--cms-input-bg);
    }
  }

  .search-btn {
    width: auto;
    min-width: 120px;
    text-transform: none;
    border-radius: 9px;
    min-height: 38px;
    font-weight: 700;
    padding: 6px 12px;
  }

  .search-query-info {
    border: 1px solid var(--cms-border);
    background: var(--cms-surface-muted);
    padding: 10px 12px;
    margin: 0;
    color: var(--cms-text-primary);
    font-size: 13px;
    font-weight: 600;
    border-radius: 10px;

    .key-value {
      font-weight: bold;
      color: #1d4ed8;
    }
  }

  .editor-region {
    border: 1px solid var(--cms-border);
    border-radius: 12px;
    overflow: hidden;
    background: #0f172a;
  }

  .page-empty {
    border: 1px dashed var(--cms-border);
    border-radius: 12px;
    background: var(--cms-surface-muted);
    padding: 26px 16px;
    text-align: center;
    color: var(--cms-text-secondary);
    font-weight: 600;
  }

  @media (max-width: 820px) {
    .search-bar {
      flex-direction: column;
      align-items: stretch;
    }

    .search-btn {
      width: 100%;
    }
  }
`

export { StyledRedis }
